import produce from "immer";
import { TableData } from "../../store/tableData/reducer/forTableId";
import { RowKey, TableRow } from "../../requests/table/types";
import { EMPTY_ARRAY } from "../../globalConsts";
import { AdminTableIdentifier } from "../../store/tableData/types";

type Ready = {
  [K in keyof TableData]: NonNullable<TableData[K]>;
} & AdminTableIdentifier;

const isTableDataReady = (data: TableData | null): data is Ready => {
  if (data === null) return false;

  const { currentPage, pages, table } = data;
  if (!currentPage || !pages?.[currentPage] || !table) {
    return false;
  }

  return true;
};

export const getRowsForPage = (
  tableData: TableData | null,
  pageNumber: number
): TableRow[] => {
  if (!isTableDataReady(tableData)) {
    return EMPTY_ARRAY;
  }
  const { pages, table } = tableData;

  const getRowFromHash = (hash: string) => table.rowsByHash[hash];
  const hashesToDisplay = Object.values(pages[pageNumber]);
  const rowsToDisplay = hashesToDisplay.map(getRowFromHash);

  return rowsToDisplay;
};
export default getRowsForPage;

export const getRowsForMobileDisplay = (
  tableData: TableData | null
): TableRow[] => {
  if (!isTableDataReady(tableData)) {
    return EMPTY_ARRAY;
  }

  const rows = produce([] as TableRow[], (draft) => {
    const { table, pages, rowsPerPage } = tableData;
    const getRowFromHash = (hash: RowKey) => table.rowsByHash[hash];

    for (let pageNr = 1; pages[pageNr]; pageNr += 1) {
      const keysOnCurrPage = Object.values(pages[pageNr]);
      const rowsForCurrentPage = keysOnCurrPage.map(getRowFromHash);
      draft.push(...rowsForCurrentPage);
      if (keysOnCurrPage.length < rowsPerPage) break; // Stránka nebyla kompletní - nepřilepuj za ní pozdější záznamy, byla by v nich díra
    }
  });

  return rows;
};
